import {RETRIEVE_PICKUP_ROUTE_LIST} from '@/api'
import {CREATE_PICKUP_ROUTE} from '@/api'
import {GET_PICKUP_ROUTE_INFO} from '@/api'
import {EDIT_PICKUP_ROUTE} from '@/api'
import {DELETE_PICKUP_ROUTE} from '@/api'
import {REGIST_STUDENT_PICKUP_ROUTE} from '@/api'
import {PARENT_GET_LIST_ROUTE} from '@/api'

export default {
  retrievePickupRouteList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      // console.log(response);
      if (response.data.data.pickup_route_list.length) {
        commit('retrievePickupRouteList', {pickupRouteList: response.data.data.pickup_route_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_PICKUP_ROUTE_LIST({}, successCallback, errorCallback)
  },

  createPickupRoute({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.pickup_route_info) {
        // commit('retrievePlaceList', {busList: response.data.data.place_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_PICKUP_ROUTE({data: payload.data}, successCallback, errorCallback)
  },

  editPickupRoute({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.pickup_route_info) {
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_PICKUP_ROUTE({data: payload}, successCallback, errorCallback)
  },

  getPickupRouteInfo({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data.pickup_route_info) {
        commit('getPickupRouteInfo', {pickupRouteInfo: response.data.data.pickup_route_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_PICKUP_ROUTE_INFO({payload}, successCallback, errorCallback)
  },

  getParentPickupRouteList({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    PARENT_GET_LIST_ROUTE({payload}, successCallback, errorCallback)
  },

  deletePickupRoute({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deletePickupRoute', {pickupRouteInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_PICKUP_ROUTE({payload}, successCallback, errorCallback)
  },

  registStudentPickupRoute({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      // commit('deletePickupRoute', {pickupRouteInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    REGIST_STUDENT_PICKUP_ROUTE({payload}, successCallback, errorCallback)
  },

  didSelectPlace({commit}, payload) {
    commit('didSelectPlace', {pickupRouteInfo: payload})
  },

  removePlace({commit}, payload) {
    commit('removePlace', {data: payload})
  },

  addPlace({commit}, payload) {
    commit('addPlace', {})
  },

  addStudent({commit}, payload) {
    commit('addStudent', {})
  },

  studentSet({commit}, payload) {
    commit('studentSet', payload)
  },

  removeStudent({commit}, payload) {
    commit('removeStudent', payload)
  }

};
